import { render, staticRenderFns } from "./afterSalePlan.vue?vue&type=template&id=28874011&scoped=true"
import script from "./afterSalePlan.vue?vue&type=script&lang=js"
export * from "./afterSalePlan.vue?vue&type=script&lang=js"
import style0 from "./afterSalePlan.vue?vue&type=style&index=0&id=28874011&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28874011",
  null
  
)

export default component.exports